/*-----------------------------------------------------------------------------------
 * Kingsoft Office Enterprise Cloud Services.
 * Copyright (c) Kingsoft Office,All rights reserved.
 *-----------------------------------------------------------------------------------*/
import { COMAPNYLIST, ADMINCOMAPNYLIST, DEFAULTCOMPANY } from './constants'
import axios from '@src/plugins/http2'
export default {
  [COMAPNYLIST]: async ({ commit }, comp_display = 'active,disabled') => {
    try {
      const { data } = await axios.get('PLUSSVR', `/api/company`, {
        comp_display: comp_display,
      })
      commit(COMAPNYLIST, data.companies)
    } catch (error) {
      commit(COMAPNYLIST, [])
    }
  },
  [ADMINCOMAPNYLIST]: async ({ commit }) => {
    try {
      const { data } = await axios.get('PLUSSVR', `/api/company`, {
        role_ids: 1,
      })
      commit(ADMINCOMAPNYLIST, data.companies)
    } catch (error) {
      commit(ADMINCOMAPNYLIST, [])
    }
  },
  [DEFAULTCOMPANY]: async ({ commit }, options = {}) => {
    try {
      const { data } = await axios.get('PLUSSVR', `/api/company/default`, {
        params: options,
      })
      commit(DEFAULTCOMPANY, data.company)
    } catch (error) {
      commit(DEFAULTCOMPANY, '')
    }
  },
}
